import { curryN, invoker, pipe, unary } from 'ramda';
import { rodnecislo } from 'rodnecislo';

// export default pipe(fetchValue, unary(rodnecislo), invoker(0, 'isValid'));

export default curryN(2, (selector, { values }) =>
  pipe(selector, unary(rodnecislo), invoker(0, 'isValid'))(values)
);
